<mat-checkbox
  class="galaxy-checkbox"
  [id]="id"
  [name]="id"
  [checked]="inputValue"
  [formControl]="formControl"
  (change)="writeValue($event.checked)"
>
  <ng-container *ngIf="!!label; else useContentInstead">
    {{ label }}
  </ng-container>
  <ng-template #useContentInstead>
    <ng-content></ng-content>
  </ng-template>
</mat-checkbox>
